import { Route, Routes, Outlet, Navigate, useLocation } from "react-router-dom";
import Mail from "./inbox/Mail";
import Inbox from "./inbox/Inbox";
import EmailListMenu from "./EmailListMenu";
import EmailHeader from "../../components/email/EmailHeader";
import Compose from "./Compose";
import Sent from "./sent/Sent";
import Starred from "./starred/Starred";
import { useSignatureInEmailQuery } from "../../Services/settingsAPIs/SignatureApi";
import NonActionable from "./nonActionable/NonActionable";

const EmailIndex = () => {
  const location = useLocation();
  const isMailRoute = location.pathname.includes("/inbox/");

  const userId = localStorage.getItem("User_Id");
  const { data: signatureData } = useSignatureInEmailQuery(
    { user_id: userId },
    {
      skip: !userId,
    },
  );

  return (
    <div id="kt_app_content_container" className="app-container mx-5 mb-3">
      {/*begin::Products*/}
      <div
        className={`card card-flush${isMailRoute ? "" : " email-index-card"}`}
      >
        {/*begin::Card header*/}
        <EmailHeader />
        <div
          className={
            isMailRoute
              ? ""
              : "d-flex flex-column flex-lg-row p-6 email-page-body"
          }
        >
          <Routes>
            <Route
              path="inbox/:uuid"
              element={<Mail signatureData={signatureData} />}
            />
            <Route element={<EmailLayout />}>
              <Route path="inbox" element={<Inbox />} />
              <Route path="starred" element={<Starred />} />
              <Route
                path="compose"
                element={<Compose signatureData={signatureData} />}
              />
              <Route path="sent" element={<Sent />} />
              <Route path="non-actionable" element={<NonActionable />} />
              <Route index element={<Navigate to="inbox" />} />
            </Route>
          </Routes>
        </div>
      </div>
    </div>
  );
};

const EmailLayout = () => (
  <>
    <EmailListMenu />
    <div className="flex-lg-row-fluid email-thread-list-host">
      <Outlet />
    </div>
  </>
);

export default EmailIndex;
